export default function Loader() {
    return (
      <div className="d-flex loader-container justify-content-center align-items-center">
        <div className="loader"></div>
      </div>
    );
  }

  export function OverlayLoader(props) {
    return (
      <div className="loader-container h-100">
        <div className={`loader-overlay ${props.className ?? ''}`}>
          <div className="loader"></div>
        </div>
      </div>
    );
  }